// frontend/src/config/agLicense.js
//
// Single source of truth for the AG Grid + AG Charts Enterprise license, plus
// the one-time AG Charts module registration that has to run before the
// first <AgCharts /> mounts. Imported by src/App.jsx, so the side-effect
// calls below fire once per bundle.
//
// AG Grid (the data grid) takes its license through <AgGridProvider
// licenseKey={AG_LICENSE_KEY}>, so its caller imports this constant and
// threads it through. AG Charts uses the static LicenseManager here.

import {
  AllEnterpriseModule as AgChartsEnterpriseModule,
  LicenseManager,
  ModuleRegistry,
} from 'ag-charts-enterprise';

export const AG_LICENSE_KEY = "Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-090395}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Manexys_B.V.}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Dobromir_Chodkowski}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Dobromir_Chodkowski}_need_to_be_licensed___{Dobromir_Chodkowski}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{23_December_2026}____[v3]_[0102]_MTc5Nzk4NDAwMDAwMA==24fe78f4057e55665697137c83bbe572";

ModuleRegistry.registerModules([AgChartsEnterpriseModule]);
LicenseManager.setLicenseKey(AG_LICENSE_KEY);
